// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1taYZ","textarea":"styles_textarea__HFatb"};